import Image from "next/image";
import Link from "next/link";
import { useTranslation } from "next-i18next";
import { useAppContext } from "@/src/config/AppProvider";
import { useRouter } from "next/router";
import useSocialMediaIcons from "@/src/utils/helpers/useSocialMediaIcons";
import Navigations from "./Navigations";
import useLocaleFlags from "@/src/utils/helpers/useLocaleFlags";
import CookieHelper from "@/src/utils/helpers/CookieHelper";

const MobileMenu = () => {
  const { mobile, setMobile } = useAppContext();
  const { licenceSettings } = useAppContext();
  const { getSocialMediaIcon } = useSocialMediaIcons();
  const { t } = useTranslation();
  const router = useRouter();
  const { locale, locales } = router;
  const { getLocaleFlag } = useLocaleFlags();

  const handleLocaleChange = async (locale: string) => {
    CookieHelper.set("NEXT_LOCALE", locale);
  };

  return (
    <div className={`popup-mobile-menu ${mobile ? "" : "active"}`}>
      <div className="inner-wrapper">
        <div className="inner-top">
          <div className="content">
            <div className="logo">
              <Link href="/">
                <Image src={licenceSettings.LogoUrl} width={152} height={50} alt={licenceSettings.SiteTitle} />
              </Link>
            </div>
            <div className="rbt-btn-close">
              <button className="close-button rbt-round-btn" onClick={() => setMobile(!mobile)}>
                <i className="feather-x"></i>
              </button>
            </div>
          </div>
          <p className="description">{licenceSettings.SiteDescription}</p>
        </div>
        <Navigations>
          {locales
            ?.filter(l => l !== locale)
            .map(l => (
              <li key={l}>
                <Link href={router.asPath} locale={l} onClick={() => handleLocaleChange(l)}>
                  <Image
                    src={getLocaleFlag(l)}
                    width={20}
                    height={14}
                    alt={locale}
                    style={{
                      borderRadius: "2px",
                      marginRight: "5px",
                      objectFit: "cover",
                      width: "20px",
                      height: "14px"
                    }}
                  />
                  {t(`locales.${l}`)}
                </Link>
              </li>
            ))}
        </Navigations>
        <ul className="navbar-top-left rbt-information-list justify-content-start">
          <li>
            <i className="feather-phone"></i>
            {licenceSettings.PhoneNumber}
          </li>
          <li>
            <Link href={`mailto:${licenceSettings.ContactEmail}`}>
              <i className="feather-mail"></i>
              {licenceSettings.ContactEmail}
            </Link>
          </li>
          <li>
            <i className="feather-map-pin"></i>
            {licenceSettings.Address}
          </li>
        </ul>
        <div className="mobile-menu-bottom">
          <div className="social-share-wrapper">
            <ul className="social-icon social-default transparent-with-border justify-content-start mt--20">
              {licenceSettings.SocialMediaLinks.map(social => (
                <li key={social.IdGuid}>
                  <Link href={social.PlatformUrl} target="_blank">
                    {getSocialMediaIcon(social.PlatformName)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
